import '.e{display:flex;}.ssr-plugin'
import '.cc{gap:12px;}.ssr-plugin'
import '.dj{cursor:pointer;}.ssr-plugin'
import '.g3{transition:opacity 150ms ease;}.ssr-plugin'
import '.g4{appearance:none;}.ssr-plugin'
import '.g5{width:18px;}.ssr-plugin'
import '.g6{height:18px;}.ssr-plugin'
import '.d6{aspect-ratio:1/1;}.ssr-plugin'
import '.c{border-radius:12px;}.ssr-plugin'
import '.ai{position:relative;}.ssr-plugin'
import '.g7{flex-shrink:0;}.ssr-plugin'
import '.g8{background:transparent;}.ssr-plugin'
import '.g9{transition:background 180ms ease, outline-color 180ms ease;}.ssr-plugin'
import { styled, Style } from 'inlines'
import { colors } from '../utils/colors.js'

type CheckboxInputProps = {
  value?: boolean
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void
  label?: React.ReactNode
  id?: string
  style?: Style
}

export const CheckboxInput = ({
  value,
  onChange,
  label,
  id,
  style,
}: CheckboxInputProps) => {
  return (
    <styled.label className="e cc dj g3"
      style={{
        '&:hover': { opacity: 0.75 },
        ...style,
      }}
    >
      <styled.input className="g4 g5 g6 d6 c dj ai g7 g8 g9"
        id={id}
        style={{
          outline: `2px solid rgba(255,255,255,0.67)`,
          '&::before': {
            content: `url('data:image/svg+xml;utf8,<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.5808 14.1463L8.25775 11.823C8.11925 11.6847 7.94517 11.6138 7.7355 11.6105C7.526 11.6073 7.34875 11.6782 7.20375 11.823C7.05892 11.968 6.9865 12.1437 6.9865 12.35C6.9865 12.5563 7.05892 12.732 7.20375 12.877L9.948 15.6212C10.1288 15.8019 10.3398 15.8923 10.5808 15.8923C10.8218 15.8923 11.0327 15.8019 11.2135 15.6212L16.777 10.0578C16.9153 9.91925 16.9862 9.74517 16.9895 9.5355C16.9927 9.326 16.9218 9.14875 16.777 9.00375C16.632 8.85892 16.4563 8.7865 16.25 8.7865C16.0437 8.7865 15.868 8.85892 15.723 9.00375L10.5808 14.1463ZM12.0017 21.5C10.6877 21.5 9.45267 21.2507 8.2965 20.752C7.14033 20.2533 6.13467 19.5766 5.2795 18.7218C4.42433 17.8669 3.74725 16.8617 3.24825 15.706C2.74942 14.5503 2.5 13.3156 2.5 12.0017C2.5 10.6877 2.74933 9.45267 3.248 8.2965C3.74667 7.14033 4.42342 6.13467 5.27825 5.2795C6.13308 4.42433 7.13833 3.74725 8.294 3.24825C9.44967 2.74942 10.6844 2.5 11.9983 2.5C13.3123 2.5 14.5473 2.74933 15.7035 3.248C16.8597 3.74667 17.8653 4.42342 18.7205 5.27825C19.5757 6.13308 20.2528 7.13833 20.7518 8.294C21.2506 9.44967 21.5 10.6844 21.5 11.9983C21.5 13.3123 21.2507 14.5473 20.752 15.7035C20.2533 16.8597 19.5766 17.8653 18.7218 18.7205C17.8669 19.5757 16.8617 20.2528 15.706 20.7518C14.5503 21.2506 13.3156 21.5 12.0017 21.5Z" fill="white"/></svg>')`,
            position: 'absolute',
            top: '-3px',
            left: '-3px',
            transformOrigin: 'center',
            transform: 'scale(0)',
            opacity: 0,
            transition:
              'transform 300ms cubic-bezier(0.34, 1.56, 0.64, 1), opacity 200ms ease',
          },
          '&:checked': {
            background: colors.secondary,
            outline: `2px solid ${colors.white}`,
          },
          '&:checked::before': {
            transform: 'scale(1)',
            opacity: 1,
          },
        }}
        type="checkbox"
        checked={value}
        onChange={onChange}
      />
      {label}
    </styled.label>
  )
}
